import { useState } from 'react'

import { Button, Icon, cn } from '@hap/components'

import { useUploadContext } from './hooks'
import { ImportProgressDialog } from './import-progress-dialog'

const circleRadius = 13
const circleCircumference = 2 * Math.PI * circleRadius

export function UploadButton() {
  const { items, importProgress, isComplete, hasErrors } = useUploadContext()
  const [detailsOpen, setDetailsOpen] = useState(false)

  if (items.length === 0) return null

  const activeItems = items.filter(
    (item) => item.status !== 'done' && item.status !== 'error',
  )
  const processingCount = activeItems.length
  const failedCount = items.filter((item) => item.status === 'error').length
  const progressOffset =
    circleCircumference - (importProgress.percent / 100) * circleCircumference
  const interactionLabel = processingCount === 1 ? 'interaction' : 'interactions'
  const title = hasErrors
    ? `${failedCount} ${failedCount === 1 ? 'interaction has' : 'interactions have'} errors`
    : isComplete
      ? 'Imports complete'
      : `${processingCount} ${interactionLabel} processing`

  return (
    <>
      <Button
        onClick={() => setDetailsOpen(true)}
        className={cn(
          'hover:bg-accent relative size-10 rounded-full p-0',
          hasErrors && 'text-destructive',
        )}
        title={title}
        variant="ghost"
        aria-label={`${title}, ${importProgress.percent}% complete`}
      >
        <svg className="absolute inset-1 size-8 -rotate-90" viewBox="0 0 32 32">
          <circle
            cx="16"
            cy="16"
            r={circleRadius}
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            className="text-muted-foreground/20"
          />
          <circle
            cx="16"
            cy="16"
            r={circleRadius}
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeDasharray={circleCircumference}
            strokeDashoffset={progressOffset}
            className={cn(
              'text-celestial transition-all duration-500',
              hasErrors && 'text-destructive',
            )}
          />
        </svg>
        <span className="relative flex size-10 items-center justify-center">
          <Icon
            name={hasErrors ? 'x' : isComplete ? 'check' : 'arrows-clockwise'}
            size={14}
            className={cn(!isComplete && !hasErrors && 'animate-spin')}
          />
        </span>
      </Button>

      <ImportProgressDialog open={detailsOpen} onOpenChange={setDetailsOpen} />
    </>
  )
}
